import React, { useState } from 'react'
import Sidebar from '../Mobile_Sidbar/Sidebar'
import { Link } from 'react-router-dom';

const Header = () => {

  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  return (
    <>

      <Sidebar show={showSidebar} toggle={toggleSidebar} />

      <header className="th-header header-layout1">

        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                <div className='d-flex justify-content-between'>
                  <div className="col-sm-2">
                    <div className="header-logo">
                      <Link to="/">
                        <img src="/assets_web/img/logo/delight_logo.jpg" alt="Delight" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-auto me-xl-auto">
                    <nav className="main-menu d-none d-xl-inline-block">
                      <ul>
                        <li>
                          <Link to="/">Home</Link>
                        </li>
                        <li>
                          <Link to="/about-us">About Us</Link>
                        </li>
                        <li>
                          <Link to="/contact-us">Contact Us</Link>
                        </li>
                      </ul>
                    </nav>
                    <button type="button" className="th-menu-toggle d-block d-xl-none"
                      onClick={toggleSidebar}
                    >
                      <i className="far fa-bars" />
                    </button>
                  </div>
                  {/* </div> */}

                  <div className="col-2 further_inquiry align-items-center d-none d-xl-inline-block">
                    <div className='phone-icon pt-3'>
                      <i className='bx bx-phone-call pt-2 pe-2'></i>
                      <div className="border-left pl-2">
                        <h6>For Further Inquiry</h6>
                        <p>8055118236</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  )
}

export default Header
